import KibanaFilterModel from './osd-filter-model';
export default class LookupFilterModel extends KibanaFilterModel {
    meta;
    lookup;
    constructor(meta) {
        super(meta);
        this.meta = meta;
        this.lookup = {
            id: meta.id,
            name: meta.name,
            field: meta.key,
            negate: meta.negate,
        };
        if (meta.alertEventId) {
            this.lookup.alertEventId = meta.alertEventId;
        }
    }
}
//# sourceMappingURL=lookup-filter-model.js.map